import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import i18next from 'i18next';

import useTypedSelector from 'hooks/useTypedSelector';
import { onLoginPublic } from 'redux/actions/auth.actions';

import LayoutContainer from 'containers/LayoutContainer';
import LoginView from 'views/LoginView';
import Loading from 'components/commons/Loading';

import { ILocationState } from 'types/router.types';
import { ILoginFormData } from 'views/LoginView/types';

import 'views/LoginView/i18n';

const ProceduresLoginContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const loading = useTypedSelector((state) => state.auth.loading);
  const location = useLocation<ILocationState>();

  const onSubmit = (formData: ILoginFormData) =>
    dispatch(onLoginPublic(formData, location?.state?.from?.pathname));

  return (
    <LayoutContainer isPublic title={i18next.t<string>('LOGIN_VIEW:TITLE')}>
      <LoginView onSubmit={onSubmit} isPublic />
      {loading && <Loading isModalMode message={i18next.t<string>('LOGIN_VIEW:LOADING')} />}
    </LayoutContainer>
  );
};

export default ProceduresLoginContainer;
